import { Toast } from "@/components/kit";

export const copyText = (text?: string) => {
  if (!text) return;
  navigator.clipboard.writeText(text);
  Toast({ description: "Copied", status: "info" });
};
